export default {
      id: "draw-usage",
      viewBox: "0 0 180 200",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#draw",
      toString: function () {
        return this.url;
      }
    }